import { render } from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { careerSitelanguages } from '@locale/locale-store';
import { setSentryContext, startSentry } from '@utils/sentry';

import App from 'components/App';
import GlobalStyles from 'components/GlobalStyles';
import LanguageRedirect from 'components/LanguageRedirect';
import { AppStoreProvider } from 'models/stores';

import { config } from './app-config';

if (config.SENTRY_URL) {
  startSentry(config.SENTRY_URL);
  setSentryContext('build', {
    buildDate: process.env.__BUILD_DATE__,
    buildRef: process.env.__BUILD_REF__,
  });
}

const basepath = process.env.VITE_BASE_PATH || '';

const root = (
  <AppStoreProvider>
    <GlobalStyles />
    <BrowserRouter basename={basepath}>
      <Routes>
        {careerSitelanguages.map((lang) => (
          <Route
            key={lang}
            path={`:name/${lang}/*`}
            element={<App lang={lang} />}
            errorElement={<RouteErrorBoundary />}
          />
        ))}

        <Route
          path=":name/*"
          element={<LanguageRedirect />}
          errorElement={<RouteErrorBoundary />}
        />
      </Routes>
    </BrowserRouter>
  </AppStoreProvider>
);

render(root, document.getElementById('root'));
